<template>
  <banner :rounded="true" :showImage="false">
    <div class="flex text-white gap-4 md:gap-8 items-center justify-center flex-wrap">
      <img
        src="../assets/under-review-2.svg"
        alt="Person reviewing the documents to imply that the application is under review"
        width="75"
        height="76"
        class="h-20 w-auto"
      />
      <div class="grid gap-2 text-base font-semibold">
        <p>Application Under Review</p>
      </div>
    </div>
  </banner>
</template>
<script>
import Banner from './Banner.vue';

export default {
  name: 'ApplicationUnderReviewCard',
  components: {
    Banner,
  },
};
</script>
